import type { RouteRecordRaw } from 'vue-router';

// Reading is in the AUTHORIZED floor, stakeholders included: an epic page is
// what a customer opens to see how far along their feature is. Which epics they
// see is the organization perimeter's job, enforced by the API.
export const epicsRoute: RouteRecordRaw = {
  path: '/epics',
  name: 'Epics',
  component: () => import('./pages/EpicsPage.vue'),
  meta: {
    title: 'Epics',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:epics:list'),
  },
};

export const epicRoute: RouteRecordRaw = {
  path: '/epics/:id',
  name: 'Epic',
  component: () => import('./pages/EpicPage.vue'),
  meta: {
    title: 'Epic',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:epics:get'),
  },
};
